import React, { useEffect, useState } from 'react'
import axiosUmbraco from '../axios/axiosUmbraco';
import { formatDate } from '../helper/formatDate';
import { Link } from 'react-router-dom';
import { useTranslate } from './TranslationText';
import axiosBackend from '../axios/axios';
import Loader from './Loader';
import SeasonsMap from './SeasonsMap/SeasonsMap';
import SeasonCard from './SeasonsMap/SeasonCard';
import CustomPopUp from './CustomPopUp';
import NewActionButton from './ActionButtons/NewActionButton';
import HomePageOverrideStyles from './HomePageOverrideStyles';
const BaseURL = process.env.REACT_APP_BACKEND_API;
const pageId = process.env.REACT_APP_SEASONS_ID;

export default function SeasonSection({ isHomePage = true }) {

    const [seasonItems, setSeasonItems] = useState([]);
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
    const currentLanguage = localStorage.getItem('ecupLang') ?? 'en';
    const { translate } = useTranslate();
    const [seasons, setSeasons] = useState([]);
    const [seasonLoading, setSeasonLoading] = useState(false);

    const take = 12;
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [total, setTotal] = useState(0);
    // getseasonsYear
    async function getSeasonYear() {
        try {
            const res = await axiosBackend('/api/Show/GetShowSeasonsList');
            if (res.status == 200) {
                if (res.data.responseCode == "200") {
                    setSeasons(res?.data?.result);
                    if (res?.data?.result.length > 0) {
                        setCurrentYear(res?.data?.result[res?.data?.result?.length - 1])
                    }
                }

            }
        } catch (error) {
            console.log('error in Getting seasons Years', error)
        }

    }

    // get data 
    async function getSeasons(year, skip, isLoadMore = false) {
        try {
            if (isLoadMore == false) {
                setSeasonLoading(true);
            } else {
                setIsLoadingMore(true);
            }
            const res = await axiosUmbraco.post(`api/Show/${isHomePage ? 'FilterShows' : 'FilterOtherShows'}`, { year: year, take: isHomePage ? 1000 : take, langauge: currentLanguage, skip: isHomePage ? 0 : skip });
            if (res.status == 200) {
                const formattedData = res?.data?.result?.map((item) => ({
                    name: item?.showName ?? '',
                    address: item?.countryName ?? '',
                    date: item?.startDate ?? '',
                    flag: item?.countryFlag ?? '',
                    showImage: item?.logo ?? '',
                    id: item?.id ?? '',
                    registrationOpen: item?.isShowRegisterStarted ?? false,
                }))
                if (isLoadMore == true) {
                    setSeasonItems((prev) => [...prev, ...formattedData]);
                    setIsLoadingMore(false);
                } else {
                    setSeasonItems(formattedData);
                    setSeasonLoading(false);
                }
                setTotal(res.data?.totalCount)
            }
        } catch (error) {
            console.error('error in getting seasons', error)
            setSeasonLoading(false);
        }
    }

    useEffect(() => {

        if (seasons.length > 0) {
            getSeasons(currentYear);
        }
    }, [currentYear, seasons])

    function goPrev() {
        if (seasonLoading) return;
        if (seasons?.includes(currentYear - 1)) {
            setCurrentYear((prev) => prev - 1);
        }
    }
    function goNext() {
        if (seasonLoading) return;
        if (seasons?.includes(currentYear + 1)) {
            setCurrentYear((prev) => prev + 1);
        }
    }

    useEffect(() => {
        getSeasonYear();
    }, [])

    return (
        <>
            <HomePageOverrideStyles key={'ovverrideStyles'} />
            <div id="seasons" className="thirdSectionContainer">
                {isHomePage &&
                    <div className="seasonSectionTitle">
                        <span className="roboto-light">  {translate('web.season', 'Season')} <span id="spn-season">{currentYear}</span> </span>
                        <div className="seasonButtonsContainer">
                            <i className={`fa fa-chevron-up  ${seasons?.includes(currentYear + 1) ? '' : 'colorbgwhite'} `} onClick={() => goNext()}></i>
                            <i className={`fa fa-chevron-down ${seasons?.includes(currentYear - 1) ? '' : 'colorbgwhite'}`} onClick={() => goPrev()}></i>
                        </div>
                    </div>
                }
                {seasonLoading ?
                    <>
                        <Loader />
                    </>
                    :
                    <>
                        {seasonItems.length > 0 &&
                            // <SeasonsMap key={'Season map'} seasonItems={seasonItems} />
                            <div className="seasonCardsContainer">
                                {seasonItems.map((x) => (
                                    <SeasonCard show={x} translate={translate} />
                                ))}
                            </div>
                        }
                        {isHomePage == false &&
                            <>
                                {isLoadingMore ? <Loader />
                                    :
                                    <>
                                        {total > seasonItems.length &&
                                            <div className="text-center mb-3">
                                                <NewActionButton
                                                    classNames='btn w-unset btn-outline-success px-4 py-2 rounded'
                                                    onClick={() => getSeasons(null, seasonItems.length, true)}
                                                    disabled={isLoadingMore}
                                                    text={translate('web.loadMore', 'Load More')}
                                                />
                                            </div>
                                        }
                                    </>
                                }
                            </>
                        }

                    </>}

            </div>
        </>
    )
}


